import { makeStyles, createStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) =>
  createStyles({
    header: {
      color: theme.palette.primary.main,
      fontWeight: "bold",
    },
    subHeader: {
      marginTop: "0.5rem",
      color: "#0000008A",
    },
    form: {
      display: "flex",
      flexDirection: "column",
      flexWrap: "wrap",
    },
    margin: {
      marginTop: "1.8rem",
    },
    subForm: {
      display: "flex",
      flexDirection: "row-reverse",
    },
    footer: {
      marginTop: "6rem",
    },
    footerItem: {
      marginTop: "3rem",
    },
  })
);

export default useStyles;
